export enum Role {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  STUDENT = 'STUDENT',
  COURSE_TEACHER = 'COURSE_TEACHER',
}
